export const URL_PARAM_STATE = 'wix-vod-state';
export const URL_PARAM_COMP_ID = 'wix-vod-comp-id';
export const URL_PARAM_VIDEO_ID = 'wix-vod-video-id';
export const URL_PARAM_PAYMENT_TYPE = 'paymentType';
export const URL_STATE_COMPLETE_PURCHASE = 'purchase-complete';
export const URL_STATE_PURCHASE = 'purchase';
export const URL_STATE_SHARE = 'share';
export const URL_STATE_SUBSCRIBE = 'subscribe';
//# sourceMappingURL=url.js.map